import { Carriers } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import * as z from "zod/v4";

export const createEodManifestForAll = {
  name: "createEodManifestForAll" as const,
  input: z.object({ carrier: z.enum(Carriers), addressName: z.string() }),
  output: z.object({ success: z.boolean() }),
};
